import { LegacyReposDocument } from 'src/graphql/actions/legacyRepos/legacyRepos.query';
import { apolloClient as client } from 'src/graphql/client/apollo-client';

export const refetchLegacyRepos = () => {
  client.cache.evict({ fieldName: 'legacyRepos' });
  client.cache.gc();
  client.refetchQueries({
    include: [LegacyReposDocument],
  });
};
